import styled from 'styled-components';
import { Checkbox, Select } from 'antd';

export const StyledCheckbox = styled(Checkbox)`
.ant-checkbox-checked .ant-checkbox-inner {
  background-color: orange !important;
  border-color: orange !important;
}

.ant-checkbox-inner {
  border-color: rgba(150, 155, 171, 1) !important;
}

`;

export const StyledSelect = styled(Select)`
  .ant-select-selection-placeholder {
    font-size: 18px !important; 
  }
`;